import { render } from "./Details.vue?vue&type=template&id=56b60a4c&scoped=true&lang=pug"
import script from "./Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Details.vue?vue&type=script&setup=true&lang=js"

import "./Details.vue?vue&type=style&index=0&id=56b60a4c&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b60a4c"]])

export default __exports__